const busStops = [
    "Medchal Bus Stop",
    "Dabilpur",
    "Medchal Checkpost",
    "CMR college",
    "Gundlapochampally",
    "Kompally",
    "Suchitra Junction",
    "Jeedimetla",
    "Chintal",
    "Balanagar",
    "Bowenpally",
    "Tadbund Junction",
    "Paradise Circle",
    "Patny",
    "Secunderabad Bus Station"
  ];
  export default busStops;
  